import { useContext } from "react";

import { SuggestedAgendaItemPanelContext } from "./SuggestedAgendaItemPanelContext";

export function useSuggestedAgendaItemPanel() {
  const context = useContext(SuggestedAgendaItemPanelContext);
  if (!context) {
    throw new Error("useSuggestedAgendaItemPanel must be used within a SuggestedAgendaItemPanelProvider");
  }
  return context;
}
